import { render } from "./SelectCategories.vue?vue&type=template&id=4263279c&scoped=true"
import script from "./SelectCategories.vue?vue&type=script&lang=js"
export * from "./SelectCategories.vue?vue&type=script&lang=js"

import "./SelectCategories.vue?vue&type=style&index=0&id=4263279c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4263279c"]])

export default __exports__